<template>
  <div class="w-full h-screen flex justify-center items-center">
    <div v-if="isLoading">
      <card-section-loader />
    </div>
    <div
      class="rounded-lg pt-36 pb-10 px-3 md:px-11 flex flex-col items-center relative"
      :class="{ 'sm:border px-9 pt-10': !isDrawer }"
      v-else
    >
      <div>
        <!-- The id in the next line maps the walkthrough to that h3 element. Please do not remove this id -->
        <h3
          class="text-black-10 font-bold text-center text-xl mb-1"
          id="cardsTourItem1"
        >
          Select A Card
        </h3>
        <p class="text-fg-muted font-normal text-xs w-60 text-center">
          Create a card and start doing dorime like Musty and Big Mide
        </p>
      </div>
      <div class="absolute -top-28 mt-1 left-1/2 card w-80">
        <img :src="card" alt="card" class="w-80" />
      </div>
      <div class="w-full flex justify-center mt-8">
        <button
          class="py-6 lg:py-7 rounded-lg bg-surface flex flex-col items-center border-main cursor-pointer pt-8 mr-6 hover-animation"
          @click="openNewCardForm"
        >
          <globe-icon />
          <p class="px-5 md:px-9 text-center mt-6 font-bold">Virtual Card</p>
        </button>
        <button
          class="rounded-lg bg-surface flex flex-col items-center border-main cursor-pointer hover-animation"
        >
          <div class="w-full flex justify-end my-2 pr-2">
            <p
              class="text-8px font-bold text-primary bg-orange-1 px-2 py-0.5 rounded-xl text-right"
            >
              Coming Soon
            </p>
          </div>
          <physical-card-icon />
          <p class="px-4 md:px-7 text-center mt-6 font-bold">Physical Card</p>
        </button>
      </div>
    </div>
    <initiate-tour-button
      @startTour="startCardsTour"
      v-if="tenantPermission('virtual-cards-access') && !isDrawer"
    />
    <app-tour
      :tourDetails="cardsTour"
      tourComponent="card"
      :displayTour="displayTour"
      @stopTour="stopTour"
    />
  </div>
</template>

<script>
import { CARDS_TOUR } from '@/utils/constants'
import card from '@/assets/v2/images/card.svg'
import fetchAllTours from '@/mixins/appTourApi.js'
import tenantIsTma from '@/mixins/tenant.js'
export default {
  mixins: [fetchAllTours, tenantIsTma],
  components: {
    AppTour: () => import('@/components/v2/app-tour/AppTour.vue'),
    GlobeIcon: () => import('@/assets/v2/icons/GlobeIcon.vue'),
    InitiateTourButton: () =>
      import('@/components/v2/app-tour/InitiateTourButton.vue'),
    PhysicalCardIcon: () => import('@/assets/v2/icons/PhysicalCardIcon.vue'),
    CardSectionLoader: () =>
      import('@/components/v2/skeletalLoaders/CardSectionLoader.vue')
  },
  props: {
    isDrawer: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      isLoading: false,
      displayTour: false,
      cardsTour: CARDS_TOUR,
      card
    }
  },
  methods: {
    startCardsTour () {
      this.$tours.cardsTour.start()
      this.displayTour = true
    },
    stopTour () {
      this.displayTour = false
    },
    openNewCardDrawer () {
      this.$emit('openCreateCardDrawer')
    },
    openNewCardForm () {
      if (this.isDrawer) {
        this.openNewCardDrawer()
      } else {
        this.$store.dispatch('appTour/updateCardsScreen', 'new-virtual-card')
      }
    }
  },
  computed: {
    isANewUser () {
      return !this.$store.state.appTour.allTours.card
    }
  },
  async mounted () {
    if (!this.isDrawer) {
      await this.fetchAllTours()
      if (this.isANewUser) {
        this.startCardsTour()
      }
    }
  }
}
</script>

<style scoped>
.card {
  transform: translateX(-50%);
}
</style>
